// facecheck
export const FACECHECK_ALLOWED = 'ALLOWED';

// game report referee
export const GRR_DRAFT         = 'DRAFT';
export const GRR_SIGNED_BY_REF = 'SIGNED_BY_REF';
export const GRR_COMPLETED     = 'COMPLETED';

// roster status
export const READY_TO_PLAY     = 'READY_TO_PLAY';
export const ROSTERS_LOCKED    = 'ROSTERS_LOCKED';
export const ROSTERS_UNLOCKED  = 'ROSTERS_UNLOCKED';